import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Divider from "@material-ui/core/Divider";
import AppRouter from "./appRoutes";
import { drawerStyles } from "./appCss";
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Collapse from "@material-ui/core/Collapse";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { connect } from "react-redux";
import { userLogout } from "../../store/actions";
import { getProfileData } from "../../store/actions/profile";
import { INVESTOR_URL } from "./investors";
import { NEW_TRANSACTION_URL } from "./transactions";
import { MAILBACK_URL } from "./mailBackRequest";
import { NAV_URL } from "./nav";
import { HISTORY_URL } from "./transactionHistory";
import CustomLoading from "../home/CustomLoader";
import { MyEarnings_URL } from "./myEarnings";
import CustomLoader from "../forms/Loader";

import {
  lastLoginIcon,
  nfoInActive,
  nfoActive,
  logoutIcon,
  HeaderLogo,
  dashboardActive,
  investorsActive,
  newTransactionActive,
  navActive,
  mailBackActive,
  transactionHistoryActive,
  ekycActive,
  earningsActive,
  dashboardInActive,
  investorsInActive,
  newTransactionInActive,
  navInActive,
  mailBackInActive,
  transactionHistoryInActive,
  ekycInActive,
  earningsInActive,
  settingsActive,
  settingsInactive,
} from "../../store/types/appEssentials";
import Footer from "../auth/footer";
import Image from "../Image";

export const EKYC_URL = `/e-KYC`;
const NFO_URL = `/nfo-funds`;

class PermanentDrawerLeft extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      pathname: "",
      responsiveDrawer: false,
    };
  }
  // componentDidMount() {
  //   this.props.getProfileData({
  //     Agent: this.props.token,
  //     UserId: this.props.userId,
  //   });
  // }
  handleClick = () => {
    this.setState({
      open: !this.state.open,
    });
    this.props.history.push(MAILBACK_URL);
  };

  goToRoute = (path) => () => {
    this.props.history.push(path);
    this.setState({
      responsiveDrawer: false,
    });

    if (!path.includes(MAILBACK_URL)) {
      this.setState({
        open: false,
      });
    }
  };

  logOut = () => {
    this.props.userLogout();
    this.props.history.replace("/");
  };
  openResponsiveDrawer = () => {
    this.setState({
      responsiveDrawer: !this.state.responsiveDrawer,
    });
  };

  render() {
    const { classes, location, tran_enable_flag } = this.props;
    const { responsiveDrawer } = this.state;
    const { pathname } = location;
    return (
      <div className={classes.root}>
        {/* <QueryAssistant /> */}
        <CustomLoader display={!!this.props.count} />
        <CssBaseline />
        <AppBar
          position="fixed"
          style={{
            background: "white",
            boxShadow: "0px 0px 1px -1px rgba(211,211,211,0.7)",
          }}
          className="dashboard-appbar"
        >
          <Toolbar
            style={{
              boxShadow: "0px 0px 3px 0px lightgray",
              borderBottom: "0.1px solid black",
            }}
          >
            <Image
              src={"/images/menu.svg"}
              onClick={this.openResponsiveDrawer}
              alt="logo"
              style={{ height: 20, width: 20, marginRight: 15 }}
            />
            <Image src={HeaderLogo} alt="logo" className="dashboard-logo" />

            <div className={classes.appbaricons}>
              <div
                className="lastLogiDiv"
                style={{ display: "flex", marginRight: 20 }}
              >
                <Image
                  src={lastLoginIcon}
                  alt="lastlogin"
                  className={classes.appabarlastlogin}
                />
                <div className={classes.lastloginmain}>
                  <span className={classes.lastloginsub}>Login time : </span>
                  {!!this.props.lastLogin ? (
                    this.props.lastLogin
                  ) : (
                    <CustomLoading type="ThreeDots" width={25} height={25} />
                  )}
                  <span
                    className={classes.lastloginsub}
                    style={{ marginLeft: 20 }}
                  >
                    Logged as
                    <span
                      style={{
                        marginLeft: 5,
                        marginRight: 20,
                        color: "gray",
                      }}
                    >
                      {this.props.userId}
                    </span>
                  </span>
                </div>
              </div>
              <Tooltip title="Logout">
                <Image
                  src={logoutIcon}
                  alt="logout"
                  className={classes.appabarlogout}
                  onClick={this.logOut}
                />
              </Tooltip>
            </div>
          </Toolbar>
        </AppBar>

        <div
          style={{
            position: "fixed",

            background: "rgba(0, 0, 0, 0.1)",
            width: 768,
            // top: 65,
            display: !!responsiveDrawer ? "block" : "none",

            height: "-webkit-fill-available",
            zIndex: 99999,
          }}
        >
          <div
            style={{
              position: "absolute",
              overflow: "scroll",
              // top: 65,
              display: "block",
              background: "white",
              height: "-webkit-fill-available",

              width: 254,
              color: "white",
              zIndex: 99998,
              left: 0,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                padding: 10,
                marginBottom: 20,
                borderBottom: "1px solid rgba(211,211,211,0.4)",
              }}
            >
              <Image src={HeaderLogo} alt="logo" className="dashboard-logo" />

              <Image
                onClick={this.openResponsiveDrawer}
                src={"/images/close.svg"}
                alt="logo"
                style={{ height: 15 }}
              />
            </div>
            <div className={classes.profilediv}>
              <div className={classes.profile}>
                <div></div>
                <div className={classes.profileimage}>
                  {!!this.props.userId
                    ? this.props.userId
                        .split(" ")
                        .reduce(
                          (p, c) => p.concat(c.charAt(0).toUpperCase()),
                          ""
                        )
                    : ""}
                </div>
                <div onClick={this.goToRoute("/settings")}>
                  <Image
                    src={
                      pathname === "/settings"
                        ? settingsActive
                        : settingsInactive
                    }
                    alt="settings"
                    className={classes.profileSettingsicon}
                  />
                </div>
              </div>
              <div className={classes.profileName}>
                {this.props.profileData.Distributor_Name}
              </div>
              <div className={classes.profilenametext}>
                {/* <div className={classes.combined}>
                  <div className={classes.profilenameMaintext}>ARN Code :</div>
                </div> */}

                <div className={classes.combined}>
                  <div className={classes.profilenamesubtext}>
                    {" "}
                    {this.props.token}
                  </div>
                </div>
              </div>
            </div>
            <Divider />
            {tran_enable_flag === "N" ? (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/dashboard")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute("/")}
                >
                  <Image
                    src={
                      pathname.includes("/dashboard")
                        ? dashboardActive
                        : dashboardInActive
                    }
                    alt="home"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/dashboard")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    Dashboard
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/investors")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(INVESTOR_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/investors")
                        ? investorsActive
                        : investorsInActive
                    }
                    alt="investor"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/investors")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    Investors
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? newTransactionActive
                        : newTransactionInActive
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    New Transaction
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/nfo-funds")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NFO_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/nfo-funds") ? nfoActive : nfoInActive
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nfo-funds")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    Create NFO Link
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/nav") ? "list-item-active" : "list-item"
                  }
                  onClick={this.goToRoute(NAV_URL)}
                >
                  <Image
                    src={pathname.includes("/nav") ? navActive : navInActive}
                    alt="nav"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/nav") ? "listTextActive" : "listText"
                    }
                  >
                    NAV
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/mailBackRequest")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.handleClick}
                >
                  <Image
                    src={
                      pathname.includes("/mailBackRequest")
                        ? mailBackActive
                        : mailBackInActive
                    }
                    alt="mailback"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    Mailback Request
                  </div>
                  <div
                    className={
                      pathname.includes("/mailBackRequest")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    {this.state.open ? <ExpandLess /> : <ExpandMore />}
                  </div>
                </div>
                <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding className="list-div">
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL)}
                      style={{
                        backgroundColor:
                          pathname.includes("/mailBackRequest") &&
                          !pathname.includes("/mailBackRequest/investor")
                            ? "rgba(0, 114, 188, 0.1)"
                            : "#FFF",
                      }}
                    >
                      <ListItemText
                        primary="Myself"
                        className="list-item-text"
                        style={{
                          color:
                            pathname.includes("/mailBackRequest") &&
                            !pathname.includes("/mailBackRequest/investor")
                              ? "rgba(0, 114, 188, 0.1)"
                              : "rgba(0, 114, 188, 0.1)",
                        }}
                      />
                    </ListItem>
                    <ListItem
                      button
                      onClick={this.goToRoute(MAILBACK_URL + "/investor")}
                      style={{
                        backgroundColor: pathname.includes(
                          "/mailBackRequest/investor"
                        )
                          ? "rgba(0, 114, 188, 0.1)"
                          : "#FFF",
                      }}
                    >
                      <ListItemText
                        className="list-item-text"
                        primary="Investor"
                        style={{
                          color: pathname.includes("/mailBackRequest/investor")
                            ? "#005DAC"
                            : "#5b5b5b",
                        }}
                      />
                    </ListItem>
                  </List>
                </Collapse>
                <div
                  className={
                    pathname.includes("/transaction-history")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(HISTORY_URL)}
                >
                  <Image
                    alt="history"
                    src={
                      pathname.includes("/transaction-history")
                        ? transactionHistoryActive
                        : transactionHistoryInActive
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/transaction-history")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    Transaction History
                  </div>
                </div>
                <div
                  className={
                    pathname.includes("/e-KYC")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(EKYC_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/e-KYC") ? ekycActive : ekycInActive
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/e-KYC")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    e-KYC
                  </div>
                </div>

                <div
                  className={
                    pathname.includes("/my-earnings")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(MyEarnings_URL)}
                >
                  <Image
                    alt="my-earnings"
                    src={
                      pathname.includes("/my-earnings")
                        ? earningsActive
                        : earningsInActive
                    }
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/my-earnings")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    View My Earnings
                  </div>
                </div>
              </div>
            ) : (
              <div className={classes.list}>
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "list-item-active"
                      : "list-item"
                  }
                  onClick={this.goToRoute(NEW_TRANSACTION_URL)}
                >
                  <Image
                    src={
                      pathname.includes("/new-transaction")
                        ? newTransactionActive
                        : newTransactionInActive
                    }
                    alt="transact"
                    className={classes.listImage}
                  />
                  <div
                    className={
                      pathname.includes("/new-transaction")
                        ? "listTextActive"
                        : "listText"
                    }
                  >
                    New Transaction
                  </div>
                </div>
              </div>
            )}
            {/* </Drawer> */}
          </div>
        </div>
        <Drawer
          className="drawer"
          variant="permanent"
          // classes={{
          //   paper: classes.drawerPaper,
          // }}
          anchor="left"
        >
          <a>
            <div className={classes.toolbar}>
              <Image src={HeaderLogo} alt="logo" className="dashboard-logo" />
            </div>
          </a>
          <div className={classes.profilediv}>
            <div className={classes.profile}>
              <div></div>
              <div className={classes.profileimage}>
                {!!this.props.userId
                  ? this.props.userId
                      .split(" ")
                      .reduce((p, c) => p.concat(c.charAt(0).toUpperCase()), "")
                  : ""}
              </div>
              <div onClick={this.goToRoute("/settings")}>
                <Image
                  src={
                    pathname === "/settings" ? settingsActive : settingsInactive
                  }
                  alt="settings"
                  className={classes.profileSettingsicon}
                />
              </div>
            </div>
            <div className={classes.profileName}>
              {this.props.profileData.Distributor_Name}
            </div>
            <div className={classes.profilenametext}>
              {/* <div className={classes.combined}>
                <div className={classes.profilenameMaintext}>ARN Code :</div>
              </div> */}

              <div className={classes.combined}>
                <div className={classes.profilenamesubtext}>
                  {" "}
                  {this.props.token}
                </div>
              </div>
            </div>
          </div>
          <Divider />
          {tran_enable_flag === "N" ? (
            <div className={classes.list}>
              <div
                className={
                  pathname.includes("/dashboard")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute("/")}
              >
                <Image
                  src={
                    pathname.includes("/dashboard")
                      ? dashboardActive
                      : dashboardInActive
                  }
                  alt="home"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/dashboard")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Dashboard
                </div>
              </div>

              <div
                className={
                  pathname.includes("/investors")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(INVESTOR_URL)}
              >
                <Image
                  src={
                    pathname.includes("/investors")
                      ? investorsActive
                      : investorsInActive
                  }
                  alt="investor"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/investors")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Investors
                </div>
              </div>
              <div
                className={
                  pathname.includes("/new-transaction")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(NEW_TRANSACTION_URL)}
              >
                <Image
                  src={
                    pathname.includes("/new-transaction")
                      ? newTransactionActive
                      : newTransactionInActive
                  }
                  alt="transact"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  New Transaction
                </div>
              </div>

              <div
                className={
                  pathname.includes("/nfo-funds")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(NFO_URL)}
              >
                <Image
                  src={
                    pathname.includes("/nfo-funds") ? nfoActive : nfoInActive
                  }
                  alt="transact"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/nfo-funds")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Create NFO Link
                </div>
              </div>

              <div
                className={
                  pathname.includes("/nav") ? "list-item-active" : "list-item"
                }
                onClick={this.goToRoute(NAV_URL)}
              >
                <Image
                  src={pathname.includes("/nav") ? navActive : navInActive}
                  alt="nav"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/nav") ? "listTextActive" : "listText"
                  }
                >
                  NAV
                </div>
              </div>
              <div
                className={
                  pathname.includes("/mailBackRequest")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.handleClick}
              >
                <Image
                  src={
                    pathname.includes("/mailBackRequest")
                      ? mailBackActive
                      : mailBackInActive
                  }
                  alt="mailback"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/mailBackRequest")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Mailback Request
                </div>
                <div
                  className={
                    pathname.includes("/mailBackRequest")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  {this.state.open ? <ExpandLess /> : <ExpandMore />}
                </div>
              </div>
              <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding className="list-div">
                  <ListItem
                    button
                    onClick={this.goToRoute(MAILBACK_URL)}
                    style={{
                      backgroundColor:
                        pathname.includes("/mailBackRequest") &&
                        !pathname.includes("/mailBackRequest/investor")
                          ? "rgba(0, 114, 188, 0.1)"
                          : "#FFF",
                    }}
                  >
                    <ListItemText
                      primary="Myself"
                      className="list-item-text"
                      style={{
                        color:
                          pathname.includes("/mailBackRequest") &&
                          !pathname.includes("/mailBackRequest/investor")
                            ? "#005DAC"
                            : "#5b5b5b",
                      }}
                    />
                  </ListItem>
                  <ListItem
                    button
                    onClick={this.goToRoute(MAILBACK_URL + "/investor")}
                    style={{
                      backgroundColor: pathname.includes(
                        "/mailBackRequest/investor"
                      )
                        ? "rgba(0, 114, 188, 0.1)"
                        : "#FFF",
                    }}
                  >
                    <ListItemText
                      className="list-item-text"
                      primary="Investor"
                      style={{
                        color: pathname.includes("/mailBackRequest/investor")
                          ? "#005DAC"
                          : "#5b5b5b",
                      }}
                    />
                  </ListItem>
                </List>
              </Collapse>
              <div
                className={
                  pathname.includes("/transaction-history")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(HISTORY_URL)}
              >
                <Image
                  alt="history"
                  src={
                    pathname.includes("/transaction-history")
                      ? transactionHistoryActive
                      : transactionHistoryInActive
                  }
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/transaction-history")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Transaction History
                </div>
              </div>
              <div
                className={
                  pathname.includes("/e-KYC") ? "list-item-active" : "list-item"
                }
                onClick={this.goToRoute(EKYC_URL)}
              >
                <Image
                  src={pathname.includes("/e-KYC") ? ekycActive : ekycInActive}
                  alt="transact"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/e-KYC") ? "listTextActive" : "listText"
                  }
                >
                  e-KYC
                </div>
              </div>

              <div
                className={
                  pathname.includes("/my-earnings")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(MyEarnings_URL)}
              >
                <Image
                  alt="my-earnings"
                  src={
                    pathname.includes("/my-earnings")
                      ? earningsActive
                      : earningsInActive
                  }
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/my-earnings")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  View My Earnings
                </div>
              </div>
              {/* <div
                className={
                  pathname.includes("/support")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute( "/support")}
              >
                <Image
                  src={
                    pathname.includes("/support")
                      ?  supportActive
                      :  supportInActive
                  }
                  alt="support"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/support")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  Support
                </div>
              </div> */}

              {/* <a
                className={"list-item"}
                href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                traget="blank"
                style={{ textDecoration: "none" }}
              >
                <Image
                  src={ "/images/mirae_raise_a_query.svg"}
                  alt="support"
                  className={classes.listImage}
                />
                <a
                  href="https://mfs.kfintech.com/mfs/generalpages/kfinkartdist_faqs.aspx"
                  traget="blank"
                  className={"listText"}
                  style={{ textDecoration: "none" }}
                >
                  FAQ's
                </a>
              </a> */}
            </div>
          ) : (
            <div className={classes.list}>
              <div
                className={
                  pathname.includes("/new-transaction")
                    ? "list-item-active"
                    : "list-item"
                }
                onClick={this.goToRoute(NEW_TRANSACTION_URL)}
              >
                <Image
                  src={
                    pathname.includes("/new-transaction")
                      ? newTransactionActive
                      : newTransactionInActive
                  }
                  alt="transact"
                  className={classes.listImage}
                />
                <div
                  className={
                    pathname.includes("/new-transaction")
                      ? "listTextActive"
                      : "listText"
                  }
                >
                  New Transaction
                </div>
              </div>
            </div>
          )}
        </Drawer>
        <main className={classes.content}>
          <AppRouter />
        </main>
        <Footer />
      </div>
    );
  }
}

PermanentDrawerLeft.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default connect(
  ({ authReducer, profileReducer, loading }) => {
    const { userId, token, lastLogin, tran_enable_flag } = authReducer;
    const { profileData } = profileReducer;
    const { count } = loading;
    return { userId, token, lastLogin, profileData, tran_enable_flag, count };
  },
  { userLogout, getProfileData }
)(withStyles(drawerStyles)(PermanentDrawerLeft));

export class QueryAssistant extends Component {
  render() {
    return (
      <div className="query-assistant">
        <a
          style={{
            cursor: "pointer",
          }}
          href="https://omni.kfintech.com/custom/mirae-webform.php"
          target="_blank"
        >
          <Image
            src={"/images/query_assistant.svg"}
            style={{ height: 100, marginBottom: 3 }}
          />
        </a>
      </div>
    );
  }
}
